var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vistor" }, [
    _c("div", { staticClass: "head" }, [
      _c("div", { staticClass: "detail" }, [
        _c(
          "div",
          { staticClass: "list" },
          [
            _c("p", { staticClass: "title", on: { click: _vm.resetClick } }, [
              _c("span", { staticClass: "w72" }, [_vm._v("修改密码")]),
              _c("img", {
                staticClass: "icon",
                attrs: {
                  src: require("@/assets/img/login/icon_arrow_right.png")
                }
              })
            ]),
            _vm.type === "org"
              ? [
                  _c("p", { staticClass: "title", on: { click: _vm.demand } }, [
                    _c("span", { staticClass: "w72" }, [_vm._v("项目需求")]),
                    _c("img", {
                      staticClass: "icon",
                      attrs: {
                        src: require("@/assets/img/login/icon_arrow_right.png")
                      }
                    })
                  ]),
                  _c(
                    "p",
                    { staticClass: "title none", on: { click: _vm.feedback } },
                    [
                      _c("span", { staticClass: "w72" }, [_vm._v("意见反馈")]),
                      _c("img", {
                        staticClass: "icon",
                        attrs: {
                          src: require("@/assets/img/login/icon_arrow_right.png")
                        }
                      })
                    ]
                  )
                ]
              : _vm._e()
          ],
          2
        ),
        _c("div", { staticClass: "button", on: { click: _vm.logout } }, [
          _vm._v("退出登录")
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }